/* NECCST variant cards: finish swatch image swap (moved from the comp inline script).
   Swaps the card photo when wood / black is chosen; reveals the labelled placeholder
   when the chosen finish has no usable image yet.
   Also (P5) swaps the CTA deep link to the matching finish variant: WOOD keeps the card's
   current action; BLACK forces the CTA to navigate to the PDP at the matching black variant
   (a real <a> link, so it stays accessible/keyboard-focusable). */
(function () {
  function applyFinish(card, btn) {
    var wrap = card.querySelector('[data-vimg]');
    if (!wrap) return;
    var img = wrap.querySelector('.vimg-photo');
    var ph = wrap.querySelector('.vimg-ph');
    var src = btn.getAttribute('data-src') || '';
    img.alt = btn.getAttribute('data-alt') || '';
    // No usable image for this finish: reveal the striped placeholder.
    if (!src) { img.style.visibility = 'hidden'; img.removeAttribute('src'); return; }
    // Already showing this finish (e.g. the server-rendered default): nothing to do.
    if (img.getAttribute('src') === src) { img.style.visibility = 'visible'; return; }
    // Preload, then swap in one frame so the current photo holds until the new one is
    // ready. Avoids the blink to the striped placeholder while the new image downloads.
    var loader = new Image();
    loader.onload = function () { img.src = src; img.style.visibility = 'visible'; };
    loader.onerror = function () { img.style.visibility = 'hidden'; img.removeAttribute('src'); };
    loader.src = src;
  }

  // Point the CTA <a> at the chosen finish's PDP deep link.
  // WOOD: keep the card's original CTA href (its current action).
  // BLACK: navigate to the PDP at the matching black variant.
  function applyCtaLink(card, btn) {
    var cta = card.querySelector('.vcta a.btn');
    if (!cta) return;
    var finish = btn.getAttribute('data-finish');
    var href = btn.getAttribute('data-href') || '';
    if (finish === 'black') {
      if (href) cta.setAttribute('href', href);
      else if (cta.getAttribute('data-cta-base')) cta.setAttribute('href', cta.getAttribute('data-cta-base'));
    } else {
      // WOOD: restore the original (rendered) action.
      var base = cta.getAttribute('data-cta-base');
      if (href) cta.setAttribute('href', href);
      else if (base) cta.setAttribute('href', base);
    }
  }

  document.querySelectorAll('.neccst .vcard .finish').forEach(function (group) {
    var card = group.closest('.vcard');
    var btns = group.querySelectorAll('.swatch');
    // Remember the CTA's original href once, so WOOD can always restore it.
    var cta = card.querySelector('.vcta a.btn');
    if (cta && !cta.getAttribute('data-cta-base')) {
      cta.setAttribute('data-cta-base', cta.getAttribute('href') || '');
    }
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) {
          var on = (b === btn);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.classList.toggle('is-active', on);
        });
        applyFinish(card, btn);
        applyCtaLink(card, btn);
      });
    });
    var active = group.querySelector('.swatch[aria-pressed="true"]') || btns[0];
    if (active) { active.classList.add('is-active'); applyFinish(card, active); applyCtaLink(card, active); }
  });
})();
